import { Link, Typography } from '@mui/material';

import RowWrap from '../common/IntakeRowWrap';

function NotACollegeWarning() {
  return (
    <RowWrap>
      <Typography style={{ marginBottom: '50px' }}>
        We are sorry, because you selected that your institution is not a 2 or 4- year accredited
        college or university, you are ineligible to apply for the Tree Campus Higher Education
        program. If you have any questions, please contact{' '}
        <Link href='mailto:highered@arborday.org'>highered@arborday.org</Link>.
      </Typography>
    </RowWrap>
  );
}

export default NotACollegeWarning;
